export const convertMonts = (months: string | number) => {
  months = Number(months)
  if (months < 12) {
    return months
  }
  return Math.floor(months / 12)
}
